import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  { project }: Boundaries["submitProjectReport"]["request"],
): State {
  const index = state.findIndex((req) => req.project.uuid === project.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { project, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { project, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  { project }: Boundaries["submitProjectReport"]["success"],
): State {
  const index = state.findIndex((req) => req.project.uuid === project.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { project, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { project, request: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  { project }: Boundaries["submitProjectReport"]["failure"],
): State {
  const index = state.findIndex((req) => req.project.uuid === project.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { project, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { project, request: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.submitProjectReportRequested]: handleRequest,
    [events.submitProjectReportSucceeded]: handleSuccess,
    [events.submitProjectReportFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
